import { TableCell, TableRow } from "@mui/material"

export function FentraImportErrorRow({ item }) {
    return (
        <TableRow>
            <TableCell sx={{ fontFamily: "monospace", fontSize: 12 }}>{item?.email}</TableCell>
            <TableCell>{item?.message}</TableCell>
        </TableRow>
    )
}
